import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from "../../../../service/api.service"
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService, NotificationType } from 'angular2-notifications';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-pvo-results',
  templateUrl: './pvo-results.component.html',
  styleUrls: ['./pvo-results.component.css']
})
export class PvoResultsComponent implements OnInit {

  @Input() app;
  @ViewChild('printBlock') printBlock!: ElementRef;
  @Output() deleteApp = new EventEmitter<any>();
  @Output() editAppType = new EventEmitter<any>();

  loading: any;
  isCollapsed = true;
  showTestLocation: any;
  themeSubjects: any = [];
  constructor(
    public api: ApiService,
    public router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private _notifications: NotificationsService,
    public translate: TranslateService) { }
  ngOnInit(): void {
  }

  printSection() {
    const printContents = this.printBlock.nativeElement.innerHTML;
    const popupWindow = window.open('', '_blank', 'width=800,height=600');
    if (popupWindow) {
      popupWindow.document.open();
      popupWindow.document.write(`
        <html>
          <head>
            <title>Печать</title>
            <style>
              @media print {
                body {
                  .pc-version {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}
.table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.table thead tr {
  background-color: #e6f0fa;
}
.table th {
  padding: 12px 15px;
  font-weight: bold;
  text-align: center;
  border: 1px solid #d1d5db;
  color: #1e3a8a;
}
.table tbody tr {
  border-bottom: 1px solid #e5e7eb;
}
.table td {
  padding: 10px 15px;
  border: 1px solid #d1d5db;
  text-align: center;
  color: #374151;
}
.table td:first-child {
  text-align: left;
}
@media (max-width: 768px) {
  .table {
    font-size: 14px
  }
  .table th,
  .table td {
    padding: 8px 10px;
  }
}
.table tbody tr:hover {
  background-color: #f9fafb;
}
                }
              }
            </style>
          </head>
          <body onload="window.print(); window.close();">
            ${printContents}
          </body>
        </html>
      `);
      popupWindow.document.close();
    }
  }

  getTheme(id: any, collapsed: any) {
    this.loading = true;
    if (collapsed == false) {
      this.api.getStatThemePVO(id)
        .subscribe((res: any) => {
          this.themeSubjects = res.items;
          this.themeSubjects.sort((a, b) => a.ord > b.ord ? 1 : -1);
          this.loading = false;
        }, (err: any) => {
          this.translate.currentLang == 'ru' ? this._notifications.create('Ошибка', err.error.errorMessage.ru,
            NotificationType.Error, 5000) : this._notifications.create('Қате', err.error.errorMessage.kk,
            NotificationType.Error, 5000);
          this.loading = false;
        });
    }
  }

  checkCertificate(id, iin, year, testType){
    this.loading = true;
    this.api.checkCertificatecheck(id, iin, year, testType)
      .subscribe((res: any) => {
        console.log(res);
        if(res.data.isExists){
          this.api.downloadCertificate(id, iin, year, testType)
              .subscribe((res: any) => {
              window.location.href = res.data.certificateDownLoadUrl;
              this.loading = false;
            });
        }else{
          this.translate.currentLang == 'ru' ? this._notifications.create('Ошибка', 'сертификат еще не доступен',
            NotificationType.Error, 5000) : this._notifications.create('Қате', 'Сертификатыңыз әлі дайын емес',
            NotificationType.Error, 5000);
          this.loading = false;
        }
      }, (err: any) => {
        this.loading = false;
      });
  }

  showEditEnt(id: number, appTypeId: number){
    this.router.navigate(['profile/history/edit/pvo/' + appTypeId], { queryParams: { id: id, appType: appTypeId} });
  }

  showTestDate(id: any){
    this.api.showedDate(id)
      .subscribe((res: any) => {
        this.showTestLocation = true;
      }, (err: any) => {
        this.loading = false;
    });
  }

  showPayment(id: number){
    this.router.navigate(['profile/applications/payment'], { queryParams: { id: id, type: 4} });
  }

  showDeleteModal(){
    this.deleteApp.emit();
  }

  showAppTypeModal(){
    this.editAppType.emit();
  }
}
